import axios from 'axios'
import snippets from '@/content/snippets'

export default {
  currentLanguage: 'uk',
  changeLanguageAsync: async function (lang) {
    lang = lang.toLowerCase()
    if(lang !== this.currentLanguage){
      this.currentLanguage = lang
      if(lang === 'uk') {
        snippets.reset()
        return
      }
      let key = `langdata-${lang}`
      let mdata = null
      if(window.sessionStorage[key]){
        try {
          mdata = JSON.parse(window.sessionStorage[key])
          console.log('Fetched data from sessionStorage')
        }
        catch(err) {
          console.log(err)
          mdata = null
        }
      }
      if(!mdata) {
        let fname = `${window.location.protocol}//${window.location.host}/i18n/${lang}.json`
        console.log('Downloading file from', fname)
        let res = await axios.get(fname)
        mdata = res.data
        window.sessionStorage[key] = JSON.stringify(mdata)
      }
      try {
        Object.assign(snippets, mdata)
        snippets.loaded = true
      }
      catch(err){
        console.log('changeLanguageErr', err)
      }
    }
  }
}